var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{class:("shadow-sm " + _vm.cardClass),attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{class:{
                'text-left': true,
                'accordion-toogler': true,
                'accordion-toogler--visible': _vm.visible
            },attrs:{"block":"","href":"#","variant":_vm.variant},on:{"click":function($event){_vm.visible = !_vm.visible}}},[_c('i',{class:{
                    'mr-2': true,
                    fas: true,
                    'fa-fw': true,
                    'fa-chevron-left': true,
                    'icon-visible': _vm.visible
                }}),_vm._v(_vm._s(_vm.title)+" ")])],1),_c('b-collapse',{attrs:{"visible":_vm.visible}},[_c('b-card-body',{attrs:{"body-class":_vm.bodyClass}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }